import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loaderActions } from "../../../redux/slices/loadingSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import requestCancellationService from "../../../services/requestCancellationService";
import { useTranslation } from "react-i18next";

const CancelBtn = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const booking = useAppSelector((state) => state.booking);
  const { t } = useTranslation();

  const dynamicCanellationHandler = async () => {
    dispatch(loaderActions.showLoader());

    const orderNo = booking.bookingNumber;
    const lastName = booking.bookingUsername;
    const agencyId = booking.agencyId;

    try {
      const response: IReqDynamicCancellation =
        await requestCancellationService(orderNo, lastName, agencyId);

      if (response.success) {
        dispatch(loaderActions.hideLoader());
        navigate("/cancelConfirm", { state: { data: response } });
      } else {
        dispatch(loaderActions.hideLoader());
        toast.error(response.message);
      }
    } catch (Exception: any) {
      dispatch(loaderActions.hideLoader());
      toast.error("send fail");
    }

    dispatch(loaderActions.hideLoader());
  };

  return (
    <button className="btnRounded w-100" onClick={dynamicCanellationHandler}>
      {t("buttons.cancel")}
    </button>
  );
};

export default CancelBtn;
